import { ColDef, ICellRendererParams } from '@ag-grid-community/core';
import { useTranslation } from '@thoughtspot/i18n';
import { Table } from '@thoughtspot/radiant-react/widgets/table/table';
import {
    Colors,
    Typography,
} from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import {
    HeaderComponentProps,
    UnderlyingDataSourcesProps,
} from '../invite-users-v2.interface';
import { normalizeData } from '../invite-users-v2.util';
import styles from './underlying-data-sources.module.scss';

export const tableOptions = {
    hasCheckboxes: false,
};

export const headerComponent: React.FC<HeaderComponentProps> = ({
    headerName,
}: HeaderComponentProps) => {
    return (
        <div>
            <Typography variant="p-small" color={Colors.grayLight} noMargin>
                {headerName}
            </Typography>
        </div>
    );
};

export const UnderlyingDataSources: React.FC<UnderlyingDataSourcesProps> = ({
    pinboardName,
    data,
}: UnderlyingDataSourcesProps) => {
    const { t } = useTranslation();
    const normalizedData = normalizeData(data);
    const text = t('invite.dataSource.liveBoardName') + pinboardName;
    const columns: ColDef[] = [
        {
            headerComponent,
            headerComponentParams: {
                headerName: t('invite.dataSource.dataSource'),
            },
            field: 'dataSource',
            width: 200,
            sortable: false,
        },
        {
            headerComponent,
            headerComponentParams: {
                headerName: t('invite.dataSource.creator'),
            },
            field: 'creator',
            width: 200,
            sortable: false,
        },
        {
            headerComponent,
            headerComponentParams: {
                headerName: t('invite.dataSource.description'),
            },
            field: 'description',
            flex: 1,
            sortable: false,
            cellRendererFramework: (params: ICellRendererParams) => (
                <Typography
                    variant="p"
                    noMargin
                    tooltipConfig={{
                        showTooltipOnlyOnEllipsis: true,
                        dataTooltipContent: params.value,
                    }}
                    ellipsis={{ rows: 1 }}
                >
                    {params.value}
                </Typography>
            ),
        },
    ];

    return (
        <div className={styles.data_sources}>
            <Typography variant="p">{text}</Typography>
            <Table.ListView
                data={normalizedData}
                options={tableOptions}
                columns={columns}
                loading={false}
                rowHeight={35}
                headerHeight={50}
                className={styles.table_data}
            />
        </div>
    );
};
